import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EnvironmentCustomService {
  public customsArray: ICustom[] = [];
  public customMetadataArray: ICustomMetadata[] = [];
  public customMetadataArrayAux = [];
  public currentCustomIndex: number;
  private _customMetadata$: Subject<ICustomMetadata[]> = new Subject<ICustomMetadata[]>();

  public editCustomMetadataProperty(previousName: string, newCustomMetadata: ICustomMetadata) {
    const environment = sessionStorage.getItem('environmentType');
    let numberEnvironment = 0;

    if (environment === 'Test')
      numberEnvironment = 1;
    if (environment === 'Production')
      numberEnvironment = 2;

    this.customsArray[numberEnvironment][previousName] = newCustomMetadata.default;
  }

  private _updateCustomMetaDataProperty(previousName: string, newCustomMetadata: ICustomMetadata) {
    const indexToUpdate = this.customMetadataArray.indexOf(this.customMetadataArray.find(c => c.name === previousName));
    this.customMetadataArray[indexToUpdate] = { ...newCustomMetadata };
  };

  private _deleteCustomPropertyFromEnvironments(name: string) {
    this.customsArray.forEach(c => {
      delete (c[name])
    });
  };


  private _addCustomPropertyToEnvironment(newCustom: ICustomMetadata) {
    const newCustomDictionary: ICustom = {};
    newCustomDictionary[newCustom.name] = newCustom.default;

    if (this.customsArray.length >= 3) {
      // Development
      this.customsArray[0] = { ...this.customsArray[0], ...newCustomDictionary }
      // Test
      this.customsArray[1] = { ...this.customsArray[1], ...newCustomDictionary }
      // Production
      this.customsArray[2] = { ...this.customsArray[2], ...newCustomDictionary }
    }
  }

  public addCustomProperty(newCustom: ICustomMetadata): boolean {
    let newCustomMetadata: ICustomMetadata;
    newCustomMetadata = { ...newCustom };
    this._addCustomPropertyToEnvironment(newCustomMetadata);
    this.customMetadataArray.unshift(newCustomMetadata);
    this._customMetadata$.next(this.customMetadataArray);
    return true;
  };

  public deleteCustomPropertyForAllEnvironments(name: string) {
    this._deleteCustomPropertyFromEnvironments(name);
    this._deleteCustomMetadataProperty(name);
  }

  private _deleteCustomMetadataProperty(name: string) {
    const indexToDelete = this.customMetadataArray.indexOf(this.customMetadataArray.find(c => c.name === name));
    if (indexToDelete > -1) {
      this.customMetadataArray.splice(indexToDelete, 1)
    }
  }

  public getCustomMetadata() {
    const environment = sessionStorage.getItem('environmentType');

    if (environment === 'Development')
      this.setEnvironmentCustoms(this.customsArray[0]);
    if (environment === 'Test')
      this.setEnvironmentCustoms(this.customsArray[1]);
    if (environment === 'Production')
      this.setEnvironmentCustoms(this.customsArray[2]);

    return this.customMetadataArray;
  }

  public setEnvironmentCustoms(environmentCustom) {
    if (environmentCustom) {
      this.customMetadataArrayAux = [];
      this.customMetadataArray.forEach((custom) => {
        custom.default = environmentCustom[custom.name];
        this.customMetadataArrayAux.push(custom);
      });
    }
  }
}
